<template>
	<div class=" animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1" @click="back()">当前位置：培训管理</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1" @click="back()">网授课程表</div>
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">课程详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回网授课程表</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 课程详情 -->
		<div class="courseMsg">
			<div class="tit f-bct">
				<div class="l">
					<div class="t1">{{pageMsg.name}}</div>
					<div class="t2">创建于 {{gsTime(pageMsg.createTime)}}</div>
				</div>
				<div class="f-ct">
					<template v-if="orderMsg.courseClass">
						<div class="submit red" v-if="orderMsg.courseClass.status==2" @click="gomonizs(orderMsg)">在线考试</div>
					</template>
					<!-- <div class="submit org" v-if="orderMsg.orderStatus==5">领取证书</div> -->
					<div class="submit" @click="link('/classStudy',{id})" v-if="!orderMsg.isStudyDeadline">进入课程学习</div>
				</div>
			</div>
			<!-- <div class="redtips">您培训的{{orderMsg.courseClass.name}}班级证书已制作完成，请尽快到文联路金泰酒店二楼领取</div> -->
			<!-- 计数 -->
			<div class="classNub f-ct">
				<el-image class="bbg" :src="require('@/static/icon72.png')"></el-image>
				<p class="t1" v-if="orderMsg.studyDeadline">学习截止日期：{{orderMsg.studyDeadline}}</p>
				<p class="t1">考试次数：{{orderMsg.examNum}}</p>
				<!-- <p class="t1">补考截止日期：{{orderMsg.examNum}}</p> -->
				<!-- <p class="t1" v-if="orderMsg.examStatus">理论成绩：{{orderMsg.examScore}}分</p> -->
				<p class="t1" v-if="orderMsg.courseClass">所在班级：{{orderMsg.courseClass.name}}</p>
			</div>
			<!-- 详情 -->
			<div class="detail f-bct">
				<div class="msg">
					<div class="titC">基础信息</div>
					<div class="item f-bct">
						<div class="t1">课程学习：</div>
						<div class="t2">{{pageMsg.studyHours}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">课程类型：</div>
						<div class="t2">{{pageMsg.categoryName}}</div>
					</div>
					<!-- <div class="item f-bct">
						<div class="t1">培训专业：</div>
						<div class="t2">无</div>
					</div> -->
					<div class="item f-bct">
						<div class="t1">课程负责人：</div>
						<div class="t2">{{pageMsg.directorName}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">收费标准：</div>
						<div class="t2 red">￥{{pageMsg.price}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">缴费截止日期：</div>
						<div class="t2">{{gsTime(pageMsg.applyDeadline)}}</div>
					</div>
					<div class="titC">报名要求</div>
					<div class="item f-bct">
						<div class="t1">报名学历要求：</div>
						<div class="t2">{{pageMsg.educationRequire}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">报名企业要求：</div>
						<div class="t2">{{pageMsg.companyRequire}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">社保要求：</div>
						<div class="t2">{{pageMsg.socialSecurityRequire}}</div>
					</div>
					<div class="titC">考试信息</div>
					<!-- <div class="item f-bct">
						<div class="t1">是否考试：</div>
						<div class="t2">是</div>
					</div> -->
					<div class="item f-bct">
						<div class="t1">是否补考：</div>
						<div class="t2">{{pageMsg.isAllowResit?'是':'否'}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">补考费用：</div>
						<div class="t2 red">￥{{pageMsg.resitPrice}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">可补考次数：</div>
						<div class="t2">{{pageMsg.resitNumberLimit}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">补考有效期：</div>
						<div class="t2">360天</div>
					</div>
				</div>
				<div class="richTxt">
					<div class="titC">培训内容</div>
					<div class="txt" v-html="pageMsg.content"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { courseOrderdetail,
coursedetail } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			orderMsg:'',
			pageMsg:'',
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		// 获取信息
		this.courseOrderdetail()
	},
	methods:{
		// 正式考
		gomonizs(item){
			localStorage.setItem("kaoName", item.courseName);
			this.link('/classTest',{id:item.id})
		},
		// 获取订单详情
		async courseOrderdetail(){
			let res = await courseOrderdetail({id:this.id});
			if(res.code==200){
				let createTime = new Date(res.data.createTime).getTime() + 24 * 60 * 60 * 1000;   //24小时 * 60分钟 * 60秒 * 1000
				res.data.endTime = this.gsTime(createTime)
				this.orderMsg = res.data
				this.coursedetail()
			}else{this.Tips(res.msg,'error')}
		},
		// 课程详情
		async coursedetail(){
			let res = await coursedetail({id:this.orderMsg.courseId});
			if(res.code==200){
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.courseMsg{
	background: #fff;
	// height: 100px;
	margin: 0 40px;
	border-radius: 20px;
	margin-top: 24px;
	padding: 0 24px;
	padding-bottom: 44px;
	.tit{
		padding-left: 4px;
		padding-top: 24px;
		padding-bottom: 24px;
		.l{
			.t1{
				font-size: 24px;
				color: #2F3541;
				font-weight: bold;
			}
			.t2{
				font-size: 16px;
				color: #A9ABB3;
				margin-top: 12px;	
			}
		}
		.submit{
			// width: 146px;
			cursor: pointer;
			padding: 0 25px;
			height: 46px;
			border-radius: 6px;
			background: #3B6492;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			color: #fff;
			margin-left: 16px;
		}
		.red{
			background: #FF5F5A;
		}
		.org{
			background: #E86F26;
		}
	}
	.redtips{
		font-size: 16px;
		color: #FF5F5A;
		text-align: right;
		transform: translateY(-20px);
	}
	.classNub{
		background: #3B6492;
		width: 100%;
		height: 60px;
		position: relative;
		padding: 0 24px;
		margin-bottom: 24px;
		.bbg{
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
		}
		.t1{
			font-size: 14px;
			color: #FFFFFF;
			margin-right: 32px;
		}
	}
	.detail{
		align-items: stretch;
		.msg{
			width: 531px;
			border: 1px solid #eee;
			padding-bottom: 28px;
			.titC{
				margin-top: 36px;
				padding-left: 28px;
				position: relative;
				font-size: 18px;
				font-weight: 600;
				margin-bottom: 20px;
				&:first-child{
					margin-top: 24px;
				}
				&::after{
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 18px;
					background: #3B6492;
				}
			}
			.item{
				margin-top: 10px;
				padding-left: 28px;
				padding-right: 22px;
				.t1{
					color: #545964;
					font-size: 14px;
				}
				.t2{
					font-size: 14px;
					color: #545964;
				}
				.red{
					color: #FF5F5A;
				}
			}
		}
		.richTxt{
			width: 959px;
			border: 1px solid #eee;
			padding-bottom: 28px;
			background: #FAFBFC;
			.titC{
				padding: 24px 0;
				padding-left: 28px;
				position: relative;
				font-size: 18px;
				font-weight: 600;
				&::after{
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 18px;
					background: #3B6492;
				}
			}
			.riceTit{
				padding: 0 28px;
				font-size: 14px;
				color: #545964;
				font-weight: bold;margin-bottom: 16px;
			}
			.txt{
				padding: 0 28px;
				font-size: 14px;
				color: #545964;
				line-height: 30px;
				margin-bottom: 24px;
			}
		}
	}
}
</style>